import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year5/Spring/PerimeterAndArea/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'PerimeterAndArea',
  field: 'Measurement',
  weeks: [9, 10],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/PerimeterAndArea/1PerimeterOfRectangles" */ './1PerimeterOfRectangles'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/PerimeterAndArea/2PerimeterOfRectilinearShapes" */ './2PerimeterOfRectilinearShapes'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/PerimeterAndArea/3PerimeterOfPolygons" */ './3PerimeterOfPolygons'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/PerimeterAndArea/4AreaOfRectangles" */ './4AreaOfRectangles'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/PerimeterAndArea/5AreaOfCompoundShapes" */ './5AreaOfCompoundShapes'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/PerimeterAndArea/6EstimateArea" */ './6EstimateArea'
        )
    })
  ]
});
export default Block;
